module.exports = __webpack_public_path__ + "img/pop_share_red.1768119790257.jpeg";